import SearchService from '../classes/SearchService';
import growthData from '../data/growth';
import Filter from '../classes/Filter';

import formatRange from '../functions/formatRange';
import getExternalLink from '../functions/getExternalLink';
import getDueHeight from '../functions/getDueHeight';

import { UNITS } from '../constants/units';
import { DEFAULT_GROWTH_RANGE } from '../constants/child';
import { DEFAULT_BIKE_COLOR } from '../constants/bike';

const growthChanges = growthData.changes;

// Shows bike will last period
export default class Estimation {

    constructor(date, height) {
        this.date = date;
        this.height = height;
    }

    // Growth coefficient shows how shild will growth during the year, f.e. 1.5 inches per year
    matchGrowthRange(months) {
        const ageFilter = growthChanges.filter(item => Number(item.ageMonthes) < months);
        return ageFilter.length ? Number(ageFilter[ageFilter.length - 1].change) : DEFAULT_GROWTH_RANGE;
    }

    // Returns how old is child and growth coefficient
    getAge() {

        let months = 0;

        if (!this.date) return;

        months = (new Date().getFullYear() - this.date.getFullYear()) * 12;
        months -= this.date.getMonth() + 1;
        months += new Date().getMonth() + 1;
        if (months <= 0) months = 0;
        const childChange = this.matchGrowthRange(months);

        return { months, childChange };
    }


    // Shows growth steps, child data in each period
    getWillLast(bike, unit, color = DEFAULT_BIKE_COLOR) {

        let months = this.getAge().months;
        let change = this.matchGrowthRange(months);
        let height = Number(this.height);
        let startMonth = months;

        const sourceLink = getExternalLink();

        // when child should change bike
        const maxHeight = getDueHeight(bike);

        const willLastDinamic = [];

        let yearCount = 0;

        while (height < maxHeight) {

            height += Number(change);
            months += 6;
            change = this.matchGrowthRange(months);

            yearCount++;

            let filter = new Filter(Math.round(height));
            let currentAgeBike = new SearchService().matchBike(filter);

            let fullAge = months / 12;

            currentAgeBike.global = `${sourceLink}/i/${currentAgeBike.folder}/${bike.wheel}/`;
            currentAgeBike.fullAge = Math.trunc(fullAge);
            currentAgeBike.months = months % 12;
            currentAgeBike.growthMonths = months;
            currentAgeBike.startMonth = startMonth;
            currentAgeBike.color = color
            currentAgeBike.heightUnit = formatRange(unit, height, UNITS.factor.inches);
            currentAgeBike.yearCount = Math.ceil(yearCount / 2);

            willLastDinamic.push({ height, change, currentAgeBike })

        }

        if (willLastDinamic.length) {
            const lastMonth = willLastDinamic[willLastDinamic.length - 1].currentAgeBike.growthMonths;
            willLastDinamic.map((item) => item.currentAgeBike.lastAge = (lastMonth - item.currentAgeBike.growthMonths) / 12)
        }

        const estimatedAge = (months - startMonth) / 12;

        const currentDate = new Date();

        const bikeDueDate = new Date(currentDate.setMonth(currentDate.getMonth() + months - startMonth)).toString();
        
        return { age: estimatedAge, dinamic: willLastDinamic, bikeDueDate, maxHeight }

    }

}


// WEBPACK FOOTER //
// ./src/classes/Estimation.js